export const TRIGGER_CONTEXT_KEY = Symbol.for("voltagent.trigger.context");
